export default "__VITE_ASSET__ElF$v0mvEldx1q5Hjg023Q__"